module.exports = __webpack_public_path__ + "media/damages/car-fl@2x-04389822.png";